import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
import { Modal, Spinner } from "react-bootstrap";
import _ from "lodash";
import { mapIcon, LANDSALE_LOGO } from "../../assets";
import { CHAIN, PLOT_STATUS } from "../../utils/constants/config";
import { AppContext } from "../walletsManagment/connectors";
import {
  addCardanoItemDetailChangeListner,
  getCardanoMintLand,
  getCardanoStatingSlot,
  getCardanoWhiteListStatus,
  getEternlUsedAddresses,
  updateAndLockPlot,
  updateAndUnlockPlot,
  updatePlotStatus,
} from "../../actions/DataActions";
import CustomLoader from "../../layout/CustomLoader";
import AV from "../../av-package";
import ModalFailure from "./ModalFailure";
import messages from "../../utils/constants/messages";

export default ({ showModal, closeModal, plotDetail }) => {
  const {
    cardanoAddress: wallet,
    cardanoWalletId,
    values,
  } = useContext(AppContext);

  const whiteListPayloadRef = useRef();
  const firestoreListnerRef = useRef(null);
  const [state, setState] = useState({
    submitting: false,
    processing: false,
    plotData: null,
    plotPrice: null,
    showErrorModal: false,
    message: null,
    intractionRemaingTime: 120,
    isEventStarted: false,
    closeModalUsingState: false,
  });

  const inventoryType = useMemo(() => {
    return plotDetail?.plot_id ? "plots" : "condos";
  }, [plotDetail]);
  const [image_loader, setImageLoader] = useState(true);
  const refCountDownCancelTimer = useRef(null);

  useEffect(() => {
    if (plotDetail?.plot_id) {
      getPlotDetail();
    }

    return () => {
      firestoreListnerRef.current?.();
    };
  }, [plotDetail?.plot_id]);

  useEffect(() => {
    if (state.closeModalUsingState) {
      closeModal(false);
    }
  }, [state.closeModalUsingState]);

  const addPlotDataChangeListener = () => {
    firestoreListnerRef.current?.();
    firestoreListnerRef.current = addCardanoItemDetailChangeListner(
      plotDetail?.plot_id,
      inventoryType,
      async (snapshot) => {
        setState((state) => ({
          ...state,
          plotData: snapshot?.data(),
        }));
      }
    );
  };
  const getPlotDetail = async () => {
    if (plotDetail?.plot_id != null) {
      const slot = await getCardanoStatingSlot();
      let curTime = +new Date().getTime();
      let isEventStarted = false;

      if (curTime >= slot?.start_time) {
        isEventStarted = true;
      }
      let owner_addresses = [];
      try {
        if (cardanoWalletId && cardanoWalletId === "eternl")
          owner_addresses = await getEternlUsedAddresses();
      } catch (error) {}

      setState((state) => ({
        ...state,
        isEventStarted,
        owner_addresses,
      }));

      addPlotDataChangeListener();
    }
  };
  const clearLockingTimmer = () => {
    if (refCountDownCancelTimer.current) {
      clearInterval(refCountDownCancelTimer.current);
      refCountDownCancelTimer.current = null;
    }
  };
  const updateIntervalTime = () => {
    setState((state) => {
      if (state.intractionRemaingTime < 30) {
        return {
          ...state,
          intractionRemaingTime: state.intractionRemaingTime + 30,
        };
      }
      return { ...state };
    });
  };
  const startLockingTimmer = () => {
    if (wallet && state.isEventStarted) {
      refCountDownCancelTimer.current = setInterval(() => {
        setState((state) => {
          if (state.intractionRemaingTime <= 1) {
            handleCloseModal(false);
            return { ...state };
          } else {
            return {
              ...state,
              intractionRemaingTime: state.intractionRemaingTime - 1,
            };
          }
        });
      }, 1000);
    }
  };

  useEffect(() => {
    if (state.plotData?.status === "AVAILABLE" && wallet) {
      setState((state) => ({
        ...state,
        processing: false,
        plotData: {
          ...state.plotData,
          owner_id: wallet,
          status: PLOT_STATUS.LOCKED,
        },
      }));

      if (state.isEventStarted) bookPlot();
    } else if (
      state.plotData?.status === "LOCKED" &&
      wallet &&
      state.plotData?.owner_id == wallet
    ) {
      if (!refCountDownCancelTimer.current) startLockingTimmer();
    }
  }, [state.plotData, wallet]);

  useEffect(() => {
    window.onbeforeunload = handleRefresh;
    return () => {
      clearLockingTimmer();
      window.onbeforeunload = null;
    };
  }, []);

  const handleRefresh = () => {
    handleCloseModal(false);
  };

  const bookPlot = () => {
    if (wallet) {
      updateAndLockPlot(plotDetail?.plot_id, inventoryType, wallet).then(
        () => {}
      );
      startLockingTimmer();
    }
  };

  const unLockPlot = () => {
    if (wallet)
      updateAndUnlockPlot(
        plotDetail?.plot_id,
        inventoryType,
        wallet,
        CHAIN.CARDANO
      );
  };

  const doUnlockWithCheck = (state) => {
    if (
      state.plotData?.status === PLOT_STATUS.LOCKED &&
      state.processing == false &&
      wallet === state.plotData?.owner_id
    ) {
      unLockPlot();
    }
  };
  const isAllowBuy = () => {
    return (
      state.isEventStarted &&
      (state.plotData?.status == PLOT_STATUS.AVAILABLE ||
        ((state.plotData?.owner_id == wallet ||
          (state.owner_addresses?.length > 0 &&
            state.owner_addresses.includes(state.plotData?.owner_id))) &&
          (state.plotData?.status == PLOT_STATUS.LOCKED ||
            state.plotData?.status == PLOT_STATUS.PROCESSING)))
    );
  };
  const handleCloseModal = (success) => {
    whiteListPayloadRef.current = false;
    if (success) {
      closeModal(true);
    } else {
      setState((state) => {
        doUnlockWithCheck(state);
        // closeModal(false);
        return { ...state, closeModalUsingState: true };
      });
    }
  };

  const imageLoaded = () => {
    setImageLoader(false);
  };

  const startBuyProcess = async () => {
    setState((state) => ({ ...state, submitting: true }));
    clearLockingTimmer();
    let eternl_addresses = [];

    if (cardanoWalletId === "eternl")
      eternl_addresses = await getEternlUsedAddresses();

    try {
      const whiteListStatus = await getCardanoWhiteListStatus(
        wallet,
        cardanoWalletId === "eternl" ? cardanoWalletId : null,
        cardanoWalletId === "eternl" ? eternl_addresses : []
      );

      if (whiteListStatus?.status == 200 && whiteListStatus?.payload) {
        let payload = whiteListStatus?.payload;
        whiteListPayloadRef.current = payload;

        if (payload?.allowCategories?.includes(plotDetail.size)) {
          const landId = plotDetail?.plot_id;
          const connected = await AV.connect(cardanoWalletId);
          const { utxos, changeAddress } = await AV.getWalletData();

          if (connected) {
            const transaction = await getCardanoMintLand(
              wallet,
              landId,
              cardanoWalletId,
              utxos
            );

            if (transaction) {
              const signature = await AV.signTx(transaction);

              await updatePlotStatus(
                plotDetail?.plot_id,
                "PROCESSING",
                inventoryType,
                wallet,
                ""
              );

              const transactionHash = await AV.submitTx(transaction, signature);

              await updatePlotStatus(
                plotDetail?.plot_id,
                "PROCESSING",
                inventoryType,
                wallet,
                transactionHash,
                cardanoWalletId
              );
              setState((state) => ({ ...state, submitting: false }));
              handleCloseModal(true);
            }
          }
        } else {
          throw {
            status: false,
            message: `You can't buy ${plotDetail.size} plot in current slot.`,
          };
        }
      } else {
        throw {
          status: false,
          message: whiteListStatus?.message,
        };
      }
    } catch (error) {
      console.log("error:::", error);
      setState((state) => ({
        ...state,
        submitting: false,
        showErrorModal: true,
        message: error?.message ?? null,
      }));
    }
  };

  const handleBuyNow = () => {
    if (wallet) {
      startBuyProcess();
    } else {
      document.getElementById("wallet-connect-btn")?.click();
      handleCloseModal(false);
    }
  };

  return (
    <Modal
      show={showModal}
      animation={false}
      dialogClassName={
        state.showErrorModal
          ? "modal-dialog modal-dialog-centered invisible"
          : "modal-dialog modal-dialog-centered"
      }
      contentClassName={"customPopup plotDetail"}
      size="xl"
    >
      {!state.submitting && (
        <button
          onClick={() => {
            handleCloseModal(false);
          }}
          className="close"
        />
      )}

      <div className="content inventoryCol">
        <div className="row">
          <div className="col-sm-12 column">
            <div className="plotImg">
              <div
                id="carouselExampleIndicators"
                className="carousel slide"
                data-ride="carousel"
                // data-bs-interval="true"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="imgHolderMain clr">
                      {image_loader && <CustomLoader />}

                      <img
                        src={
                          plotDetail?.size
                            ? process.env.REACT_APP_VLAND_ASSETS_PATH +
                              `plot-image-for-monster-zone/${_.startCase(
                                plotDetail?.size?.toLowerCase()
                              )}.png`
                            : LANDSALE_LOGO
                        }
                        onLoad={imageLoaded}
                        alt=""
                        style={{
                          display: !image_loader ? "block" : "none",
                          maxWidth: "100%",
                        }}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 offsetColumn">
            <div className="plotInfo">
              <div className="topInfo">
                <h3 className="title title-sm">
                  {plotDetail?.plot_name ??
                    state.plotData?.name ??
                    state.plotData?.plot_name ??
                    plotDetail?.size}
                </h3>
                <h4 className="title title-sm price">
                  ${state.plotData?.price ? state.plotData?.price : "-"}
                </h4>

                <ul className="listing">
                  <li>
                    <div>Blockchain</div>
                    <p>
                      {plotDetail?.blockchain == CHAIN.CARDANO && "Cardano"}
                    </p>
                  </li>
                </ul>
              </div>
              <div className="bottomInfo">
                <div className="location">
                  <img src={mapIcon} alt="" />
                  <span className="place">Monster Zone</span>
                </div>

                <button
                  disabled={state.submitting || (!isAllowBuy() && wallet)}
                  className={
                    isAllowBuy()
                      ? state.submitting
                        ? `custom-btn accent-bg lg bg-transparent w-100`
                        : `custom-btn accent-bg lg w-100`
                      : `custom-btn accent-bg lg bg-transparent w-100`
                  }
                  onClick={() => handleBuyNow()}
                >
                  {state.submitting ? (
                    <>
                      <Spinner size="sm" className=" mx-2 " /> Verifying
                    </>
                  ) : wallet ? (
                    "BUY NOW"
                  ) : (
                    "Connect Wallet"
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className="col-12">
            {!state.submitting && (
              <div className="mobile-btn">
                <button
                  onClick={() => {
                    handleCloseModal(false);
                  }}
                  className="custom-btn gray-bg lg"
                >
                  Close
                </button>
              </div>
            )}
          </div>

          <div className="col-12">
            {!state.plotData ? (
              <div className="verifying">
                <Spinner size="sm" />
              </div>
            ) : state.isEventStarted ? (
              <div
                className={`verifying ${
                  state.intractionRemaingTime && refCountDownCancelTimer.current
                    ? ""
                    : "d-none"
                }`}
              >
                <div className="timer">Time Remaining:</div>
                <span className="buy-lock-time">
                  {state.intractionRemaingTime} Seconds
                </span>
              </div>
            ) : (
              <div className="verifying">{messages.event_not_started}</div>
            )}

            {/* {state.intractionRemaingTime &&
                    refCountDownCancelTimer.current && (
                      <div className="verifying ">
                        <div className="timer">Time Remaining:</div>
                        <span className="buy-lock-time">
                          {state.intractionRemaingTime} Seconds
                        </span>
                      </div>
                    )} */}
          </div>
        </div>

        <ModalFailure
          showModal={state.showErrorModal}
          message={state.message}
          closeModal={() => {
            handleCloseModal(false);
          }}
        />
      </div>
    </Modal>
  );
};
